<app-topnav></app-topnav>

<!-- HEADER -->
<app-header-secondary-a [pageTitle]="'nouvelles.title' | translate" 
[pageDescription]="'nouvelles.description' | translate"></app-header-secondary-a>
<!-- end HEADER -->

<section  id="section-nouvelles">

<div class="container" *ngIf="!nbNouvelles">

    <p> {{ 'nouvelles.aucune' | translate }}</p>

</div>

<div class="container" *ngIf="nbNouvelles!=0">

        <div class="" *ngFor="let Nouvelle of listeNouvelles">
            <div *ngIf="currentLang ==='fr'">
                <div><a [routerLink]="['/nouvelles', Nouvelle.id]">{{Nouvelle.titreFR}}</a></div>
                <div>{{Nouvelle.texteFR}}</div>
                <div class="date">{{Nouvelle.dateFR}}</div>
                <br>
            </div>
            <div *ngIf="currentLang ==='en'">
                    <div><a [routerLink]="['/nouvelles', Nouvelle.id]">{{Nouvelle.titreEN}}</a></div>
                    <div>{{Nouvelle.texteEN}}</div>
                    <div class="date">{{Nouvelle.dateEN}}</div>
                    <br>
                </div>
            </div>
    
    </div>
    
</section>

<p>&nbsp;</p>
<p>&nbsp;</p>

<app-footer></app-footer>